<template>
  <ul class="contact-container">
    <li>
      <a href="">
        <div class="icon">
          <Icon type="qq" />
        </div>
        <span>{{ data.qq }}</span>
      </a>
      <div class="pop">
        <img
          :src="$serverURL + data.qqQrCode"
          alt=""
        />
      </div>
    </li>
    <li>
      <a href="">
        <div class="icon">
          <Icon type="weixin" />
        </div>
        <span>{{ data.weixin }}</span>
      </a>
      <div class="pop">
        <img
          :src="$serverURL + data.weixinQrCode"
          alt=""
        />
      </div>
    </li>
    <li>
      <a
        target="_blank"
        :href="data.github"
      >
        <div class="icon">
          <Icon type="github" />
        </div>
        <span>{{ data.githubName }}</span>
      </a>
      <!-- <div class="pop">
        <img
          src="../img/1.png"
          alt=""
        />
      </div> -->
    </li>
    <li>
      <a :href="`mailto:${data.mail}`">
        <div class="icon">
          <Icon type="mail" />
        </div>
        <span>{{ data.mail }}</span>
      </a>
      <!-- <div class="pop">
        <img
          src="../img/1.png"
          alt=""
        />
      </div> -->
    </li>
  </ul>
</template>

<script>
import Icon from "@/components/Icon.vue";
import { mapState } from "vuex";
export default {
  components: {
    Icon,
  },
  computed: mapState("setting", ["data"]),
};
</script>

<style scoped lang="less">
@import "../style/var.less";
.contact-container {
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  color: @gray;
  @itmeHeight: 30px;
  li {
    height: 30px;
    line-height: 30px;
    margin: 14px 0;
    cursor: pointer;
    position: relative;
    text-indent: 10px;
    &:hover {
      .pop {
        transform: scaleY(1);
      }
    }
  }
  a {
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  .icon {
    font-size: 26px;
    width: 36px;
  }
  .pop {
    position: absolute;
    left: 10px;
    bottom: @itmeHeight;
    padding: 10px 15xp;
    background: #fff;
    border-radius: 5px;
    width: 150px;
    height: 150px;
    transform: scaleY(0);
    transform-origin: center bottom;
    transition: 0.3s;
    img {
      width: 140px;
      height: 140px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 5px;
    }
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%) rotate(45deg);
      width: 8px;
      height: 8px;
      background: #fff;
      bottom: -4px;
    }
  }
}
</style>
